import { ActionReducerMapBuilder, Dispatch, Draft, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NoInfer } from '@reduxjs/toolkit/dist/tsHelpers';

import { BebyggelseobjektPubliceradIndex, HTTP_STATUS, ModelError, State } from 'models';

import type { RootState } from './rootReducer';
import { errorOr, fulfilled, pending, rejected } from './storeHelpers';

import BebyggelseApi from 'api/bebyggelseApi';

const requestCondition = (getState: () => unknown): false | undefined => {
  const { publiceradeBebyggelseobjekt } = getState() as RootState;
  if (publiceradeBebyggelseobjekt.requestStatus === 'pending') return false;
};

export const getPubliceradeBebyggelseobjekt = createAsyncThunk<
  BebyggelseobjektPubliceradIndex[],
  string,
  { rejectValue: ModelError }
>(
  'get/allPubliceradeBebyggelseobjekt',
  async (id: string, { rejectWithValue }): Promise<any> => {
    const response: Response = await BebyggelseApi.aktivitet.getPublicerade(id);
    return errorOr(response, rejectWithValue, [HTTP_STATUS.INTERNAL_SERVER_ERROR, HTTP_STATUS.SERVICE_UNAVAILABLE]);
  },
  {
    condition: (id: string, { getState }) => requestCondition(getState)
  }
);

const initialState: State<BebyggelseobjektPubliceradIndex[]> = {
  data: undefined,
  error: undefined,
  requestStatus: 'idle',
  requestType: undefined,
  currentRequestId: undefined
};

export const clearPubliceradeBebyggelseobjekt = () => {
  return (dispatch: Dispatch) => {
    dispatch(clearPubliceradeBebyggelseobjektState());
  };
};

const PubliceradeBebyggelseobjektSlice = createSlice({
  name: 'publiceradeBebyggelseobjekt',
  initialState,
  reducers: {
    clearPubliceradeBebyggelseobjektState: (state: Draft<State<BebyggelseobjektPubliceradIndex[]>>): void => {
      state.data = undefined;
    }
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<State<Array<BebyggelseobjektPubliceradIndex>>>>): void => {
    builder.addCase(
      getPubliceradeBebyggelseobjekt.pending,
      (state: Draft<State<Array<BebyggelseobjektPubliceradIndex>>>, action): void => pending(state, action)
    );
    builder.addCase(
      getPubliceradeBebyggelseobjekt.fulfilled,
      (state: Draft<State<Array<BebyggelseobjektPubliceradIndex>>>, action): void => fulfilled(state, action)
    );
    builder.addCase(
      getPubliceradeBebyggelseobjekt.rejected,
      (state: Draft<State<Array<BebyggelseobjektPubliceradIndex>>>, action): void => rejected(state, action)
    );
  }
});

export const { clearPubliceradeBebyggelseobjektState } = PubliceradeBebyggelseobjektSlice.actions;

export default PubliceradeBebyggelseobjektSlice.reducer;
